import {
  Badge,
  BadgeProps,
  createStyles,
  Group,
  Stack,
  Text,
  Title,
} from '@mantine/core';
import React from 'react';

import { StoreListing } from '@portals/api/partners';
import { TextEditor, TextEditorProps } from '@portals/core';
import { StoreListingStatusBadge } from '@portals/framework';
import { VerticalScrollBar } from '@portals/scrollbar';

import { useStoreListingWizard } from '../hooks';

export function EditModeProductInformation() {
  const { classes } = useStyles();
  const { contextData } = useStoreListingWizard();

  const product = contextData.storeListing?.product;

  return (
    <div className={classes.container}>
      <Stack spacing="xs" mb={42}>
        <Group position="apart" noWrap>
          <Title order={5} weight={400} truncate>
            {product?.name}
          </Title>

          <StoreListingStatusBadge
            status={contextData.storeListing?.status as StoreListing['status']}
            sx={{ flexShrink: 0 }}
          />
        </Group>

        {product?.category ? (
          <Badge size="lg" styles={badgeStyles}>
            {product?.category}
          </Badge>
        ) : null}

        {product?.subtitle ? (
          <Text color="gray.6">{product.subtitle}</Text>
        ) : null}
      </Stack>

      <VerticalScrollBar>
        <TextEditor
          styles={textEditorStyles}
          editorParams={{ content: product?.description, editable: false }}
        />
      </VerticalScrollBar>
    </div>
  );
}

const useStyles = createStyles((theme) => ({
  container: {
    maxWidth: 560,
    display: 'grid',
    gridTemplateRows: 'auto 1fr',
  },
}));

const badgeStyles: BadgeProps['styles'] = (theme) => ({
  root: {
    alignSelf: 'flex-start',
    color: theme.white,
    backgroundColor: theme.colors.blue_gray[9],
  },
  inner: {
    fontSize: theme.fontSizes.xs,
    fontWeight: 500,
    textTransform: 'uppercase',
  },
});

const textEditorStyles: TextEditorProps['styles'] = (theme) => ({
  root: {
    border: 'none',
  },
  typographyStylesProvider: {
    color: theme.colors.gray[8],
  },
  content: {
    '.ProseMirror': {
      paddingBlock: 0,
      paddingLeft: 0,
    },
  },
});
